import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import FaqServices from "../../services/FaqServices";
import Pagetitle from "../../component/PageTitle";

function AddFaqCategory() {
    const navigate = useNavigate();
    const [formValues, setFormValues] = useState({
        titleEnglish: "",
        titleHindi: "",
    });


    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormValues((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (formValues.price <= formValues.offerPrice) {
            alert('Price should be greater than Offer Price.');
            return;
        }
        try {
            const formData = new FormData();
            for (const key in formValues) {
                // Check if the value is not null or undefined
                if (formValues[key] !== null && formValues[key] !== undefined) {
                    formData.append(key, formValues[key]);
                }
            }

            const response = await FaqServices.AddFaqCategory(formValues);

            alert("Faq Category Added Successfully");
            navigate("/faq-category-list");
        } catch (error) {
            console.error("Failed to add Faq Category", error);
            alert(error.response.data.message || 'Failed to add Faq Category');
        }
    };

    return (
        <div className="right_col" role="main">
            <Pagetitle />
            <div className="container-box">
                <div className="container-box-top-header justify-content-between">
                    <div className="sub-title-box-right">
                        <Link className="site-btn-green" to="/faq-category-list">
                            Faq Category List
                        </Link>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="container-box">
                        <div className="container-box-inner px-4">
                            <div className="page-details">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                            <div className="input-field">
                                                <label>Add Category (English)*</label>
                                                <input
                                                    type="text"
                                                    name="titleEnglish"
                                                    className="form-control"
                                                   value={formValues.titleEnglish}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter Category English Name"
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="input-field">
                                                <label>Add Category (Hindi)*</label>
                                                <input
                                                    type="text"
                                                    name="titleHindi"
                                                    className="form-control"
                                                    value={formValues.titleHindi}
                                                    onChange={handleInputChange}
                                                    placeholder="Enter Category Hindi Name"
                                                    required
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <button className="site-btn-green" type="submit">
                                        Save
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default AddFaqCategory;
